module.exports = __webpack_public_path__ + "img/galileo_en.9c88063a.png";